import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImportService } from '../../../services/import.service';

@Component({
  selector: 'app-alternate-titles-modal',
  templateUrl: './alternate-titles-modal.component.html',
  styleUrls: ['./alternate-titles-modal.component.scss']
})
export class AlternateTitlesModalComponent implements OnInit {

  
  alternateTitles = [];

  show: any;
  constructor(
    private dialogRef: MatDialogRef<AlternateTitlesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private importService: ImportService,
  ) { }

  get seasonNumbers(): string {
    return this.show.seasons.map(season => `Season ${season.season_number}`).join(', ');
  }

  ngOnInit() {
    if (this.data.show) {
      this.show = this.data.show;
    }
  }
  close() {
    this.dialogRef.close();
  }

}
